const asciis = [
  `
  ▄▀▀█▄▄   ▄▀▀█▄   ▄▀▀▀▀▄   ▄▀▀▄ ▄▄   ▄▀▀█▄   ▄▀▀▄ ▄▀▀▄  ▄▀▀▀▀▄ 
  █ ▄▀   █ ▐ ▄▀ ▀▄ █      █ █  █   ▄▀ ▐ ▄▀ ▀▄ █   █    █ █ █   ▐ 
  ▐ █    █   █▄▄▄█ █      █ ▐  █▄▄▄█    █▄▄▄█ ▐  █    █     ▀▄   
    █    █  ▄▀   █ ▀▄    ▄▀    █   █   ▄▀   █   █    █   ▀▄   █  
   ▄▀▄▄▄▄▀ █   ▄▀    ▀▀▀▀     ▄▀  ▄▀  █   ▄▀     ▀▄▄▄▄▀   █▀▀▀   
  █     ▐  ▐   ▐             █   █    ▐   ▐               ▐      
  ▐                          ▐   ▐                               
  welcomes you`,
  `
  ▓█████▄  ▄▄▄       ▒█████   ██░ ██  ▄▄▄       █    ██   ██████ 
  ▒██▀ ██▌▒████▄    ▒██▒  ██▒▓██░ ██▒▒████▄     ██  ▓██▒▒██    ▒ 
  ░██   █▌▒██  ▀█▄  ▒██░  ██▒▒██▀▀██░▒██  ▀█▄  ▓██  ▒██░░ ▓██▄   
  ░▓█▄   ▌░██▄▄▄▄██ ▒██   ██░░▓█ ░██ ░██▄▄▄▄██ ▓▓█  ░██░  ▒   ██▒
  ░▒████▓  ▓█   ▓██▒░ ████▓▒░░▓█▒░██▓ ▓█   ▓██▒▒▒█████▓ ▒██████▒▒
   ▒▒▓  ▒  ▒▒   ▓▒█░░ ▒░▒░▒░  ▒ ░░▒░▒ ▒▒   ▓▒█░░▒▓▒ ▒ ▒ ▒ ▒▓▒ ▒ ░
   ░ ▒  ▒   ▒   ▒▒ ░  ░ ▒ ▒░  ▒ ░▒░ ░  ▒   ▒▒ ░░░▒░ ░ ░ ░ ░▒  ░ ░
   ░ ░  ░   ░   ▒   ░ ░ ░ ▒   ░  ░░ ░  ░   ▒    ░░░ ░ ░ ░  ░  ░  
     ░          ░  ░    ░ ░   ░  ░  ░      ░  ░   ░           ░  
   ░                                                             
   welcomes you`,
  `                                                                       
  @@@@@@@    @@@@@@    @@@@@@   @@@  @@@   @@@@@@   @@@  @@@   @@@@@@   
  @@@@@@@@  @@@@@@@@  @@@@@@@@  @@@  @@@  @@@@@@@@  @@@  @@@  @@@@@@@   
  @@!  @@@  @@!  @@@  @@!  @@@  @@!  @@@  @@!  @@@  @@!  @@@  !@@       
  !@!  @!@  !@!  @!@  !@!  @!@  !@!  @!@  !@!  @!@  !@!  @!@  !@!       
  @!@  !@!  @!@!@!@!  @!@  !@!  @!@!@!@!  @!@!@!@!  @!@  !@!  !!@@!!    
  !@!  !!!  !!!@!!!!  !@!  !!!  !!!@!!!!  !!!@!!!!  !@!  !!!   !!@!!!   
  !!:  !!!  !!:  !!!  !!:  !!!  !!:  !!!  !!:  !!!  !!:  !!!       !:!  
  :!:  !:!  :!:  !:!  :!:  !:!  :!:  !:!  :!:  !:!  :!:  !:!      !:!   
  :::: ::  ::   :::  ::::: ::  ::   :::  ::   :::  ::::: ::  :::: ::   
  :: :  :    :   : :   : :  :    :   : :   :   : :   : :  :   :: : :    
                                                                        
  welcomes you`,
];

export const asciiLog = () => {
  console.log(asciis[Math.floor(Math.random() * asciis.length)]);
};
